"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CASE_STATUS_FILTER = void 0;
exports.CaseStatusFilterMenuHeader = CaseStatusFilterMenuHeader;
const react_1 = __importDefault(require("react"));
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const StatusFilterMenuHeader_1 = require("./StatusFilterMenuHeader");
/** Domyślny filtr statusów spraw w selektorze: aktywne (bez 'Zamknięta'). */
exports.DEFAULT_CASE_STATUS_FILTER = [MainSetupReact_1.default.CaseStatus.FOR_LATER, MainSetupReact_1.default.CaseStatus.IN_PROGRESS];
/** Pasek filtra statusów spraw w menu selektora sprawy - patrz StatusFilterMenuHeader. */
function CaseStatusFilterMenuHeader({ selectedStatuses, onChange, }) {
    return (react_1.default.createElement(StatusFilterMenuHeader_1.StatusFilterMenuHeader, { allStatuses: Object.values(MainSetupReact_1.default.CaseStatus), selectedStatuses: selectedStatuses, onChange: onChange }));
}
